import request from '@/utils/server'
export function budget(query) {
    return request({
      url: '/procurement/budget',
      method: 'get',
      params: query
    })
  }